import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import { showPhoneError, showPhoneSuccess } from '../helpers/phoneAlerts';

export default class UnlinkModal extends Modal {
    className() {
        return `SMSAuthUnlinkModal Modal--small`;
    }

    title() {
        return app.translator.trans(`lakevy-phone-binding.forum.modals.unlink.title`);
    }

    content() {
        return (
            <div className="Modal-body">
                <div className="Form Form--centered">
                    <div className="Form-group" id="submit-button-group">
                        <h3>{app.translator.trans(`lakevy-phone-binding.forum.modals.unlink.title`)}</h3>
                        <p className={`SMSAuthText--danger`}><i className="fas fa-exclamation-triangle fa-fw" />
                            <b>为保护社团账号交接安全，请先向当前绑定手机号发送验证码。</b>
                        </p>
                        <input className="FormControl bottom"
                            placeholder={app.translator.trans(`lakevy-phone-binding.forum.modals.link.code`)}
                            oninput={e => this.code = e.target.value}
                            disabled={this.loading}
                        />
                        <div className="ButtonGroup">
                            <Button className={'Button'} loading={this.sending} disabled={this.sending || this.loading}
                                onclick={() => this.sendSMS()}>
                                {app.translator.trans(`lakevy-phone-binding.forum.buttons.send`)}
                            </Button>
                            <Button type={'submit'} className={`Button Button--primary SMSAuthUnlinkConfirm`} icon={'fas fa-unlink'}
                                loading={this.loading} disabled={!this.code || this.loading}>
                                {app.translator.trans(`lakevy-phone-binding.forum.modals.unlink.confirm`)}
                            </Button>
                            <Button className={'Button SMSAuthUnlinkCancel'}
                                onclick={() => this.hide()} disabled={this.loading}>
                                {app.translator.trans(`lakevy-phone-binding.forum.modals.unlink.cancel`)}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onsubmit(e) {

        e.preventDefault();
        this.loading = true;
        const user = app.session.user;
        user
          .save({
            phone: "",
            code: this.code,
          })
          .catch((error) => {
                showPhoneError(error);
            })
          .then((result) => {
                if (!result) return;
                this.hide();
                m.redraw();
                showPhoneSuccess('unlink_success');
                window.location.reload();
          });
    }

    sendSMS() {
        this.sending = true;
        app.request({
            url: app.forum.attribute('apiUrl') + '/auth/sms/unlink/send',
            method: 'POST',
            // The catch below provides the localized alert for this request.
            errorHandler: () => {},
        }).then((result) => {
            if (result.status) {
                showPhoneSuccess('send_success');
            } else {
                showPhoneError(result.msg);
            }
        }).catch((error) => {
            showPhoneError(error);
        }).finally(() => {
            this.sending = false;
            m.redraw();
        });
    }
}
